import { useState } from 'react'

import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_AD_UNIT_BIDDERS } from './api/query'
import { AdUnitBidderSliceDTO, Data, Variables } from './api/types'
import { AdUnitBidderSlice, Props, UseGetAdUnitBidders } from './types'

export const useGetAdUnitBidders = ({
  domainBidder,
  filters,
  first,
  last,
  sort,
}: Props): UseGetAdUnitBidders => {
  const ability = useAbility()
  const [adUnitBidders, setAdUnitBidders] = useState<AdUnitBidderSlice[]>([])
  const [count, setCount] = useState<number>(0)

  const {
    csParamsSchema,
    domain: { id: domainId },
    s2sParamsSchema,
    workspaceBidder: { id: workspaceBidderId },
  } = domainBidder

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const { nodes, totalCount: count } = data.adUnitBidders

      if (nodes) {
        setAdUnitBidders(
          nodes.map((adUnitBidder: AdUnitBidderSliceDTO) =>
            fromDTO(adUnitBidder, csParamsSchema, s2sParamsSchema),
          ),
        )
        setCount(count)
      }
    },
    query: GET_AD_UNIT_BIDDERS(ability),
    variables: {
      domainId,
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceBidderId,
    },
  })

  return {
    adUnitBidders,
    count,
    loading: isLoading,
  }
}
